//Utilities
var EventEmitter = require('events').EventEmitter;
var assign = require('object-assign');
var _ = require('lodash');
var AppDispatcher = require('../core/AppDispatcher.jsx');
var ApplicationAPI = require('../apis/ApplicationsAPI');
var Mapper = require('../utils/Mapper.js');
var Content = require('../services/ContentService').getContent();

//constants
var ActionTypes = require('../constants/AutoRebalancingConstants.js').ActionTypes;
var YesNoValues = require('../constants/ApplicationConstants.js').YesNoValues;
var AutoRebalancingFields = require('../constants/AutoRebalancingConstants.js').AutoRebalancingFields;
var Values = require('../constants/AutoRebalancingConstants.js').Values;
var ApplicationActionTypes = require('../constants/ApplicationConstants.js').ActionTypes;
var InvAllocationActionTypes = require('../constants/InvestmentAllocationConstants').ActionTypes;

//local variables
var CHANGE_EVENT = 'change';
var _errorList = [], _inlineErrorList = [], _isManagedAccount = false;
var _isHideFrequency = true;
var _showAllocationInvOptions = true;
var _showInSpecieInvOptions = false;
var _isInSpecieManuallyEntered = false;

var _errors = {
    hasInvestmentOptions: true,
    hasValidInvestmentOptions: true,
    hasFrequency: true
}

var model = {
    option: {
        value: YesNoValues.NO
    },
    frequency: {
        value: ''
    },
    changedField: ''
}

var _allocationInvOptions = [];
var _inSpecieInvOptions = [];
var _fullInvestmentOptionList = [];
var _list = [];

function setInvestmentAllocations(investmentOptions) {
    
    _allocationInvOptions = _.cloneDeep(investmentOptions);
    setList();
    setInlineErrors();
    validateInvestmentOptions();
    setErrorList();
    getFrequencyVisibility();
}

function setInSpecieModel(data)
{
    _showInSpecieInvOptions = data.inSpecieModel.setUp === YesNoValues.YES;
    _showAllocationInvOptions = data.inSpecieModel.setUp === YesNoValues.NO ||
        (data.inSpecieModel.setUp === YesNoValues.YES && data.inSpecieModel.externalAccountQuestion !== YesNoValues.YES);

    var accounts = _.cloneDeep(data.inSpecieAccounts);
    var investmentOptions = _.flatten(_.map(accounts, 'investmentOptions'));
    _inSpecieInvOptions = _.reduce(investmentOptions, function (result, value) {
        if (_.isString(value)) {
            value = value.replace(/,/g, '');
        }
        if (!_.find(result, { id: value.id }) && parseFloat(value.balance) > 0) {
            result.push(value);
        }
        return result;
    }, []);
    
    if (_showInSpecieInvOptions) {
        _isInSpecieManuallyEntered = _.some(accounts,
            function (o) {
                return o.isExistingAccount === false;
            });
    } else {
        _isInSpecieManuallyEntered = false
    }

    setList();
    setInlineErrors();
    validateInvestmentOptions();
    setErrorList();
    getFrequencyVisibility();
}

function setInlineErrors() {
    var classAutoRebalancing = 'auto-rebalancing';
    if (model.option.value === YesNoValues.YES) {
        if (!_list.length) {
            _errors.hasInvestmentOptions = false;
            model.frequency.value == '';
            _isHideFrequency = true;
            _inlineErrorList.push({ message: Content.autoRebalancing.investmentOptionRequiredError, id: classAutoRebalancing });

        } else {
            _errors.hasInvestmentOptions = true;
        }
    }
}

function setList() {
    if (_isInSpecieManuallyEntered) {
        _list = _.cloneDeep(_fullInvestmentOptionList);
    }else if (_showAllocationInvOptions && _showInSpecieInvOptions) {
        _list = _.cloneDeep(_allocationInvOptions);
        _.forEach(_inSpecieInvOptions,
            function (s) {
                if (!_.find(_list, { id: s.id })) {
                    _list.push(s);
                }
            });
    } else if (_showAllocationInvOptions) {
        _list = _.cloneDeep(_allocationInvOptions);
    } else if (_showInSpecieInvOptions) {
        _list = _.cloneDeep(_inSpecieInvOptions);
    } else {
        _list = []
    }
}

function isInvalidInvestmentOption() {
    var validList = [];
    // return list that is not termDeposit and isFirstRateInvestment
    validList = _.where(_list, { isFirstRateInvestment: false, termDeposit: false });
    if (validList.length > 1) {
        return true;
    } else {
        return false;
    }
}

function updateAutoRebalancing(data) {
    if (data) {
        Mapper.objectMerger(model, data);
        if (data.changedField === AutoRebalancingFields.AUTO_REBALANCING_OPTIONS) {
            validateInvestmentOptions();
        }
        else if (data.changedField === AutoRebalancingFields.FREQUENCY_OPTIONS) {
            validateFrequency();
        }
        setErrorList();
    }
    getFrequencyVisibility();
}

function getFrequencyVisibility() {
    if (model.option.value === YesNoValues.NO) {
        _isHideFrequency = true;
        _errors.hasInvestmentOptions = true;
        _errors.hasValidInvestmentOptions = true;
        _errors.hasFrequency = true;
    }
    else if (_isHideFrequency && (!_errors.hasInvestmentOptions || !_errors.hasValidInvestmentOptions)) {
        _isHideFrequency = true;
    }
    else {
        if (_isHideFrequency) {
            model.frequency.value = '';
        }
        _isHideFrequency = false;
    }
}

function validateFrequency() {
    if (model.frequency.value === '') {
        _errors.hasFrequency = false;
    }
    else {
        _errors.hasFrequency = true;
    }
}

function validateInvestmentOptions() {
    if (_list.length > 0) {
        // check for invalid investment options
        _errors.hasValidInvestmentOptions = isInvalidInvestmentOption();
        _errors.hasInvestmentOptions = true;
    }
    else {
        //inline error if no investment option added
        _errors.hasValidInvestmentOptions = true;
        _errors.hasInvestmentOptions = false;
    }
}

function validateAutoRebalancing() {
    validateInvestmentOptions();
    validateFrequency();
}

function setErrorList() {
    var errors = [];
    var autoRebalancing = Content.autoRebalancing.autoRebalancingCopy;
    var classAutoRebalancing = 'auto-rebalancing';

    _errorList = [];
    _inlineErrorList = [];

    //push to error summary
    if (model.option.value === YesNoValues.YES) {
        //list contains invalid investment options
        if (!_errors.hasValidInvestmentOptions) {
            errors.push({ message: Content.common.investmentOptionInvalid, clickable: autoRebalancing, id: classAutoRebalancing });
            _inlineErrorList.push({ message: Content.autoRebalancing.investmentOptionInvalidError, id: classAutoRebalancing })
        }
        else if (!_errors.hasInvestmentOptions) {
            errors.push({ message: Content.common.investmentOptionRequired, clickable: autoRebalancing, id: classAutoRebalancing });
            _inlineErrorList.push({ message: Content.autoRebalancing.investmentOptionRequiredError, id: classAutoRebalancing })
        }
        else if (!_errors.hasFrequency) { // missing frequency option during save
            errors.push({ message: Content.autoRebalancing.missingFrequencyRequired, clickable: autoRebalancing, id: 'auto-rebalancing-frequency' });
            _inlineErrorList.push({ message: Content.autoRebalancing.missingFrequencyRequiredError, id: 'auto-rebalancing-frequency' })
        }
    }
    _errorList = errors;
}

function retrieveAutoRebalancing(data) {
    if (data) {
        var isManagedAccount = _.get(data, 'form.investmentAllocation.isManagedAccount');
        setIsManagedAccount(isManagedAccount);
        if (!isManagedAccount) {
            var autoRebalancing = _.get(data, 'form.autoRebalancing');
            if (autoRebalancing) {
                model.option.value = autoRebalancing.setAutoRebalancing;
                model.frequency.value = autoRebalancing.frequency;

                //show frequency options during retrieve if annually/quarterly
                if (model.frequency.value === Values.ANNUALLY || model.frequency.value === Values.QUARTERLY) {
                    model.option.value = YesNoValues.YES;
                    _isHideFrequency = false;
                }
            }
        }
    }
}

function setFullInvestmentOptionList(fullInvestmentOptionList) {
    _fullInvestmentOptionList = _.cloneDeep(fullInvestmentOptionList);
}

function setIsManagedAccount(isManagedAccount) {
    _isManagedAccount = isManagedAccount;
    if (_isManagedAccount) {
        model.option.value = YesNoValues.NO;
        model.frequency.value = '';
    }
}

var AutoRebalancingStore = assign({}, EventEmitter.prototype, {

    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function (callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function (callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getErrorList: function () {
        return _errorList;
    },
    getInlineErrorList: function () {
        return _inlineErrorList;
    },
    isValid: function () {
        ApplicationAPI.saveAutoRebalancing(model.option.value, model.frequency.value);
        if (_errorList.length > 0) {
            return false;
        } else return true;
    },
    getAutoRebalancing: function () {
        return model.option.value;
    },
    getFrequency: function () {
        return model.frequency.value;
    },
    isHideFrequency: function () {
        return _isHideFrequency;
    },
    getAutoRebalancingModel: function () {
        var formModel = {
            SetAutoRebalancing: YesNoValues.NO,
            Frequency: ''
        }
        formModel.SetAutoRebalancing = model.option.value;
        formModel.Frequency = model.frequency.value;

        return formModel;
    },
    getIsInSpecieManuallyEntered: function () {
        return _isInSpecieManuallyEntered;
    },
    getIsManagedAccount: function () {
        return _isManagedAccount;
    }

});

AutoRebalancingStore.setMaxListeners(0);

AutoRebalancingStore.dispatchToken = AppDispatcher.register(function (action) {

    switch (action.actionType) {
        case ActionTypes.UPDATE_AUTO_REBALANCING:
            updateAutoRebalancing(action.data);
            break;
        case ApplicationActionTypes.APPLICATION_RETRIEVE_SUCCESS:
            retrieveAutoRebalancing(action.applicationData);
            break;
        case ApplicationActionTypes.VALIDATE_APPLICATION:
            //perform validation
            validateAutoRebalancing();
            getFrequencyVisibility();
            setErrorList();
            break;
        case ApplicationActionTypes.SEND_INVESTMENT_OPTIONS:
            setInvestmentAllocations(action.investmentOptionList);
            break;
        case ApplicationActionTypes.SEND_INSPECIE_DATA:
            setInSpecieModel(action.data);
            break;
        case InvAllocationActionTypes.RECEIVE_INVESTMENT_OPTION_LIST:
            setFullInvestmentOptionList(action.investmentOptionList);
            break;
        case ApplicationActionTypes.SEND_IS_MANAGED_ACCOUNT:
            setIsManagedAccount(action.isManagedAccount);
            break;
        default:
            return true;
    }
    AutoRebalancingStore.emitChange();
    return true;
});

module.exports = AutoRebalancingStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/AutoRebalancingStore.js